module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#share",
      toString: function () {
        return this.url;
      }
    }